import { render, staticRenderFns } from "./news-faq-detail.vue?vue&type=template&id=3111fc79&"
import script from "./news-faq-detail.vue?vue&type=script&lang=js&"
export * from "./news-faq-detail.vue?vue&type=script&lang=js&"
import style0 from "./news-faq-detail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports